/**
 * Force Initialize Multicolumn Sliders
 * This ensures that even if the theme's main observer misses the section,
 * the Splide carousel will mount and apply the necessary classes for mobile.
 */
function initMobileSliders() {
  const multicolumns = document.querySelectorAll('splide-carousel');
  
  multicolumns.forEach(carousel => {
    const splideEl = carousel.querySelector('.splide');
    if (splideEl && !splideEl.classList.contains('is-initialized')) {
      const optionsAttr = splideEl.getAttribute('data-splide');
      if (optionsAttr) {
        try {
          const options = JSON.parse(optionsAttr);
          // Only force slider on mobile/tablet if configured
          const splideInstance = new Splide(splideEl, options);
          splideInstance.mount();
          console.log('Multicolumn Slider forced initialization successful');
        } catch (e) {
          console.error('Failed to force init Splide:', e);
        }
      }
    }
  });
}

document.addEventListener('DOMContentLoaded', () => {
  // 1. Disable native restoration
  if ('scrollRestoration' in history) {
    history.scrollRestoration = 'manual';
  }

  // 2. Save scroll position AND URL on click
  document.addEventListener('click', (e) => {
    const productLink = e.target.closest('.product-link');
    
    if (productLink) {
      sessionStorage.setItem('sundown_plp_scroll', window.scrollY);
      sessionStorage.setItem('sundown_plp_url', window.location.pathname);
    }
  });

  // 3. Smart Scroll Restoration with Polling
  window.addEventListener('pageshow', (event) => {
    const scrollPos = sessionStorage.getItem('sundown_plp_scroll');
    const savedUrl = sessionStorage.getItem('sundown_plp_url');
    const currentUrl = window.location.pathname;
    
    if (scrollPos && savedUrl === currentUrl) {
      const targetScroll = parseInt(scrollPos, 10);
      let attempts = 0;
      
      // Check the page height every 100ms
      const scrollInterval = setInterval(() => {
        attempts++;
        
        // If the total page height is finally taller than our saved scroll position
        if (document.documentElement.scrollHeight > targetScroll) {
          window.scrollTo({ top: targetScroll, behavior: 'instant' });
          
          // Stop checking and clean up storage
          clearInterval(scrollInterval);
          sessionStorage.removeItem('sundown_plp_scroll'); 
          sessionStorage.removeItem('sundown_plp_url'); 
          
        } else if (attempts >= 20) {
          // Give up after 2 seconds (20 attempts) to prevent it running forever
          clearInterval(scrollInterval);
          sessionStorage.removeItem('sundown_plp_scroll'); 
          sessionStorage.removeItem('sundown_plp_url'); 
        }
      }, 100);
    }
  });
});